<app-import-file
  [isLoading]="isLoading"
  [progressValue]="progressValue"
  [textError]="textError"
  [filesError]="filesError"
  (closeDrawer)="closeDrawer.emit()"
  (fileDrop)="onDrop($event)"
  (reloadEvent)="reload()"
  (searchEvent)="loadData($event)">
  <div import-file-header class="flex items-center gap-2">
    <div class="drawer-content-screen__title">
      {{ 'uploadContacts' | translate }}
    </div>
    @if (isExportingTemplate) {
      <div class="h-[2.5rem] w-[2.5rem]">
        <app-loader padding="0" [diameter]="'22'" height="100%"></app-loader>
      </div>
    } @else {
      <button
        mat-icon-button
        [attr.aria-label]="'exportTemplate' | translate"
        (click)="exportTemplate()"
        matTooltip="{{ 'exportTemplate' | translate }}">
        <span class="material-symbols-outlined">sim_card_download</span>
      </button>
    }
  </div>

  <div import-file-content>
    <table
      mat-table
      class="w-full"
      [dataSource]="importDataSource"
      matSort
      matSortDisableClear>
      <ng-container matColumnDef="fileName">
        <th class="w-[15%]" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ columnHeaders.fileName | translate }}
        </th>
        <td class="w-[15%]" mat-cell *matCellDef="let file">
          <span class="break-all">{{ file.fileName }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="alias">
        <th class="w-[15%]" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ columnHeaders.alias | translate }}
        </th>
        <td class="w-[15%]" mat-cell *matCellDef="let file">
          <span class="break-all">{{ file.alias ?? '' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th class="w-[25%]" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ columnHeaders.email | translate }}
        </th>
        <td class="w-[25%]" mat-cell *matCellDef="let file">
          <span class="break-all">{{ file?.email ?? '' }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="state">
        <th class="w-[12%]" mat-header-cell *matHeaderCellDef>
          <div class="flex items-center">
            {{ columnHeaders.state | translate }}
            <button
              mat-icon-button
              [matMenuTriggerFor]="contactImportStateMenu">
              <mat-icon class="icon" [class.blue]="filter !== null"
                >filter_list</mat-icon
              >
            </button>
          </div>
        </th>
        <td class="w-[12%]" mat-cell *matCellDef="let file">
          <div class="flex items-center justify-between gap-[0.2rem]">
            {{ getStateLabel(file.state) | translate }}
            <div class="w-[40px]">
              @if (
                file.state === importContactState.Error ||
                file.state === importContactState.Missed
              ) {
                <mat-icon class="icon" color="warn"> error_outline </mat-icon>
              }
              @if (file.state === importContactState.Imported) {
                <mat-icon class="icon" color="primary"> done </mat-icon>
              }
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="message">
        <th class="w-[14%]" mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ columnHeaders.message | translate }}
        </th>
        <td class="w-[14%]" mat-cell *matCellDef="let file">
          @if (file?.isDuplicate) {
            <div>{{ 'errorDuplicateContact' | translate }}</div>
          }
          <div class="flex flex-col">
            <div>{{ file?.error?.message ?? '' }}</div>
            <div>{{ file?.error?.field ?? '' }}</div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    @if (!importDataSource.data.length) {
      <app-no-data></app-no-data>
    }
    <mat-menu #contactImportStateMenu (click)="$event.stopPropagation()">
      @for (state of stateOptions; track state.id) {
        <button type="button" mat-menu-item (click)="setFilterChange(state.id)">
          <span [class.blue]="filter === state.id">{{
            state.title | translate
          }}</span>
        </button>
      }
    </mat-menu>
  </div>
</app-import-file>
